(function (Utils) {

	"use strict";

	/* globals PLUG */

// =============================================================================
// POLYFILL
// Array.prototype.includes, Array.from
// =============================================================================
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
	if (!Array.prototype.includes) {
		Object.defineProperty(Array.prototype, "includes", {
			value: function (searchElement, fromIndex) {
				if (this == null) {
					throw new TypeError("'this' is null or not defined");
				}
				var o = Object(this);
				var len = o.length >>> 0;
				if (len === 0) {
					return false;
				}
				var n = fromIndex | 0;
				var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
				function sameValueZero(x, y) {
					return x === y || (typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y));
				}
				while (k < len) {
					if (sameValueZero(o[k], searchElement)) {
						return true;
					}
					k++;
				}
				return false;
			}
		});
	}

	if (!Array.from) {
		// Production steps of ECMA-262, Edition 6, 22.1.2.1
		Array.from = (function () {
			var symbolIterator;
			try {
				symbolIterator = Symbol.iterator
					? Symbol.iterator
					: "Symbol(Symbol.iterator)";
			} catch (e) {
					symbolIterator = "Symbol(Symbol.iterator)";
			}
			var toStr = Object.prototype.toString;
			var isCallable = function (fn) {
					return (
							typeof fn === "function" ||
							toStr.call(fn) === "[object Function]"
					);
			};
			var toInteger = function (value) {
					var number = Number(value);
					if (isNaN(number)) return 0;
					if (number === 0 || !isFinite(number)) return number;
					return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
			};
			var maxSafeInteger = Math.pow(2, 53) - 1;
			var toLength = function (value) {
					var len = toInteger(value);
					return Math.min(Math.max(len, 0), maxSafeInteger);
			};
			var setGetItemHandler = function setGetItemHandler(isIterator, items) {
					var iterator = isIterator && items[symbolIterator]();
					return function getItem(k) {
							return isIterator ? iterator.next() : items[k];
					};
			};
			var getArray = function getArray(T, A, len, getItem, isIterator, mapFn) {
				var k = 0;
				while (k < len || isIterator) {
					var item = getItem(k);
					var kValue = isIterator ? item.value : item;
					if (isIterator && item.done) {
						return A;
					} else {
						if (mapFn) {
							A[k] =
								typeof T === "undefined"
									? mapFn(kValue, k)
									: mapFn.call(T, kValue, k);
						} else {
							A[k] = kValue;
						}
					}
					k += 1;
				}
				if (isIterator) {
					throw new TypeError(
						"Array.from: provided arrayLike or iterator has length more then 2 ** 52 - 1"
					);
				} else {
						A.length = len;
				}
				return A;
			};
			return function from(arrayLikeOrIterator /*, mapFn, thisArg */) {
				var C = this;
				var items = Object(arrayLikeOrIterator);
				var isIterator = isCallable(items[symbolIterator]);
				if (arrayLikeOrIterator == null && !isIterator) {
						throw new TypeError(
								"Array.from requires an array-like object or iterator - not null or undefined"
						);
				}
				var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
				var T;
				if (typeof mapFn !== "undefined") {
					if (!isCallable(mapFn)) {
						throw new TypeError(
							"Array.from: when provided, the second argument must be a function"
						);
					}
					if (arguments.length > 2) {
						T = arguments[2];
					}
				}
				var len = toLength(items.length);
				var A = isCallable(C) ? Object(new C(len)) : new Array(len);
				return getArray(T, A, len, setGetItemHandler(isIterator, items), isIterator, mapFn);
			};
		})();
	}


// =============================================================================
// GENERAL
// =============================================================================

	/**
	* @param {function} fcn - When this function returns a truthy value, we are done.
	* @param {function} cb - The callback function we call when fcn evaluates to
	*  a truthy value. If a timeout occurs, we pass cb the arguments: null, "timeout".
	* @param {number} interval - (optional) The minimum number of milliseconds to
	*  wait in between checks. Default is 200.
	* @param {number} limit - (optional) The maximum number of failures we
	*  allow before throwing an error. Default is 50.
	*/
	var waitUntilTrue = function (fcn, cb, interval, limit) {
		if (fcn()) {
			return cb();
		}

		if (interval === undefined) {
			interval = 200;
		}

		if (limit === undefined) {
			limit = 50;
		}

		limit -= 1;
		if (limit === 0) {
			return cb(null, "timeout");
		}

		setTimeout(waitUntilTrue, interval, fcn, cb, interval, limit);
	};


	// Returns the value for the param with the give name, or null if no value is found.
	// queryString is optional, default is location.search.
	var getUrlParam = function (name, queryString) {
		queryString = queryString || location.search;

		// Remove the question mark prefix from the queryString if needed.
		if (queryString.charAt(0) === "?") {
			queryString = queryString.slice(1);
		}

		var params = queryString.split("&");
		var paramMatch = params.find(function (param) {
			return (param.split("=")[0] === name);
		});
		return (
			paramMatch !== undefined
			? paramMatch.split("=")[1]
			: null
		);
	};

	//  Run an array of requestors synchronously.
	var runSequence = function (requestors, cb, initialValue) {
		var nextNumber = 0;
		startRequestor(initialValue);
		function startRequestor(value, reason) {
			if (value === null) {
				return cb(null, reason);
			} else if (nextNumber < requestors.length) {
				var number = nextNumber;
				nextNumber += 1;
				var requestor = requestors[number];
				requestor(
					function (value, reason) {
						return startRequestor(value, reason);
					},
					value
				);
			} else {
				return cb(value);
			}
		}
	};

	//  Run an array of requestors asynchronously.
	var runParallel = function (requestors, cb, initialValue, timeLimit) {
		try {
			if (timeLimit === undefined) {
				timeLimit = false;
			}

			var timer;
			if (timeLimit) {
				timer = setTimeout(function () {
					requestors = undefined;
					console.log("Error", " run_async instance has exceeded its time limit.");
				}, timeLimit);
			}

			var errorOccurred;
			var reasons = [];
			var numCheckedIn = 0;

			var checkIn = function (data, reason) {
				if (data === null) {
					console.log("Error: ", reason);
					errorOccurred = true;
				}
				numCheckedIn += 1;
				if (numCheckedIn === requestors.length) {
					if (timer) {
						clearTimeout(timer);
					}
					return (
						errorOccurred
						? cb(null, reasons)
						: cb()
					);
				}
			};
			var i = 0;
			while (i < requestors.length) {
					var requestor = requestors[i];
					setTimeout(requestor, 0, checkIn, initialValue);
					i += 1;
			}
		} catch (reason) {
			return cb(null, reason);
		}
	};


// =============================================================================
// STRING MANIPULATION
// =============================================================================

	var capitalize = function (str) {
		var chars = str.split("");
		chars[0] = chars[0].toUpperCase();
		return chars.join("");
	};


	var camelCase = function (str, capitalizeFirstLetter = true) {
		var sepRegex = /[ -_]+/g;
		var parts = str.split(sepRegex);
		parts = parts.map(capitalize);
		if (!capitalizeFirstLetter) {
			parts[0] = parts[0].toLowerCase();
		}
		return parts.join("");
	};

	// var removeTrailingZeros = function (num) {
	// 	num = Number(num);
	// 	var str = String(num);
	// 	var parts = str.split(".");
	// 	if (parts.length === 1) {
	// 		return num;
	// 	}
	// 	var decimalDigitsReverse = parts[1].split("").reverse();
	// 	var correctedDecimalDigits = parts[1].split("");
	// 	var k = 0;
	// 	while (k < decimalDigitsReverse.length) {
	// 		if (decimalDigitsReverse[k] !== "0") {
	// 			break;
	// 		}
	// 		correctedDecimalDigits.pop();
	// 		k += 1;
	// 	}
	// 	return Number([parts[0], correctedDecimalDigits.join("")].join("."));
	// };


// =============================================================================
// DOM MANIPULATION
// =============================================================================

	// Dynamically create 'icon-spinner' snippet.
	// Private
	var loadingSvg = function () {
		var ns = "http://www.w3.org/2000/svg";
		var svg = document.createElementNS(ns, "svg");
		svg.setAttribute("aria-hidden", "true");
		svg.setAttribute("focusable", "false");
		svg.setAttribute("role", "presentation");
		svg.setAttribute("class", "icon icon-spinner");
		svg.setAttribute("viewBox", "0 0 24 24");
		var path = document.createElementNS(ns, "path");
		path.setAttribute("d", "M8.177 7.376l-3.042-5.268 1.731-1 3.044 5.273c-.634.237-1.221.571-1.733.995zm-2.177 4.624c0-.341.035-.674.09-1h-6.09v2h6.09c-.055-.326-.09-.659-.09-1zm1.377-3.824l-5.269-3.042-1 1.732 5.273 3.044c.237-.635.572-1.222.996-1.734zm8.447-.799l3.043-5.271-1.731-.999-3.046 5.275c.635.236 1.222.571 1.734.995zm1.795 2.534l5.276-3.046-1.001-1.731-5.27 3.042c.424.513.758 1.1.995 1.735zm-5.619-3.911c.341 0 .674.035 1 .09v-6.09h-2v6.09c.326-.055.659-.09 1-.09zm2.09 11.618l3.045 5.274 1.731-1-3.042-5.27c-.512.425-1.099.76-1.734.996zm-7.708-3.528l-5.272 3.044 1 1.732 5.268-3.042c-.425-.512-.76-1.099-.996-1.734zm11.528-3.09c.055.326.09.658.09 1s-.035.674-.09 1h6.09v-2h-6.09zm-1.286 4.823l5.27 3.043.999-1.732-5.274-3.045c-.237.635-.571 1.222-.995 1.734zm-8.447.801l-3.041 5.268 1.732 1 3.044-5.272c-.635-.237-1.223-.572-1.735-.996zm3.823 1.376c-.341 0-.674-.035-1-.09v6.09h2v-6.09c-.326.055-.659.09-1 .09z");
		path.setAttribute("fill", "currentColor");
		svg.appendChild(path);
		var wrapper = document.createElement("span");
		wrapper.setAttribute("data-loader", true);
		wrapper.className = "hide";
		wrapper.appendChild(svg);
		return wrapper;
	};


	/**
	 * @purpose - To start and stop a button's loading animation.
	 * @param {object} button - An element or jquery object.
	 * @param {boolean} loading - If true, we start the animation, otherwise we stop it.
	 */
	var setButtonLoadingState = function (button, loading) {
		button = button.jquery ? button[0] : button;
		var loader = button.querySelector("[data-loader]");
		var content = button.querySelector("[data-button-content]");

		if (!loader) {
			loader = loadingSvg();

			if (!content) {
				content = document.createElement("span");
				content.setAttribute("data-button-content", "true");
				var k = 0;
				var numChildNodes = button.childNodes.length;
				while (k < numChildNodes) {
					var childNodeK = button.childNodes[k];
					// If it is an element or text node.
					if (childNodeK.nodeType === 1 || childNodeK.nodeType === 3) {
						content.appendChild(childNodeK);
					}
					k += 1;
				}
				button.appendChild(content);
			}
			button.appendChild(loader);
		}

		// This happens when loader is present but content is not.
		if (!content) {
			return;
		}

		if (loading) {
			button.disabled = true;
			content.style.opacity = "0";
			loader.classList.remove("hide");
		} else {
			button.disabled = false;
			loader.classList.add("hide");
			content.style.opacity = "1";
		}
	};


	/**
	 * @purpose - To equalize the heights of a set of elements.
	 * @param {array} elements - An array containing two or more elements.
	 * @param {boolean} updateOnResize - If true, we call this function on resize.
	 */
	var setElementsToHeightOfTallest = function (elements, updateOnResize, flexGrow) {
		if (elements.length < 2) {
			return;
		}
		if (flexGrow === undefined) {
			flexGrow = 0;
		}
		// The heights are updated on resize by default.
		if (updateOnResize === undefined) {
			updateOnResize = true;
		}
		// Determine the greatest element height and set the height of every element to it.
		var updateHeights = function () {
			// Remove any existing style.height value.
			// Set flexgrow to 0 to ensure an accurate height is obtained.
			elements.forEach(function (element) {
				element.style.flexGrow = "0";
				element.style.height = "";
			});

			// Get the max height.
			var maxHeight = 0;
			elements.forEach(function (element) {
				var elementHeight = element.offsetHeight();
				if (elementHeight > maxHeight) {
					maxHeight = elementHeight;
				}
			});

			// Set the height of all elements to maxHeight.
			elements.forEach(function (element) {
				element.style.height = maxHeight + "px";
				element.style.flexGrow = flexGrow;
			});
		};

		updateHeights();

		// Set up a throttled resize listener to trigger updateHeights after resizes.
		if (updateOnResize) {
			var resizeTimer;
			window.addEventListener("resize", function () {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(updateHeights, 200);
			});
		}

		// We add this to perform a secondary check, as sometimes it seems to trigger too early.
		resizeTimer = setTimeout(updateHeights, 2000);
	};


// =============================================================================
// REQUESTS
// =============================================================================

	var makeXmlRequest = function (options, cb) {
		var req = new XMLHttpRequest();

		// OPTIONS
		var method = options.method; // e.g. "GET"
		var url = options.url; // e.g. "https://domainName"
		var requestBody = options.requestBody; // (optional) Data object
		var headerData = options.headerData; // (optional) Object, e.g. { "Content-Type": "application/json", ... }
		var responseType = options.responseType; // (optional) e.g. "document"

		req.open(method, url, true);

		if (responseType) {
			req.responseType = responseType;
		}

		// Set any headers defined in headerData.
		if (headerData) {
			Object.keys(headerData).forEach(function (key) {
				req.setRequestHeader(key, headerData[key]);
			});
		}

		var contentTypeSpecified = (
			headerData
			&& headerData["Content-Type"] !== undefined
		);

		if (requestBody && !contentTypeSpecified) {
			req.setRequestHeader("Content-Type", "application/json");
		}

		// Set up a listener which is triggered when the request is complete.
		req.onreadystatechange = function () {
			if (req.readyState === req.DONE) {
				if (req.status.toString().charAt(0) === "2") {
					var results = (
						(responseType === "document")
						? req.responseXML
						: req.responseText
					);
					if (cb) {
						return cb(results);
					}
				} else {
					var errorMsg = "Bad request: status code: " + req.status + " " + req.results;
					if (cb) {
						return cb(null, errorMsg, req.response);
					} else {
						throw new Error(errorMsg);
					}
				}
			}
		};

		req.send(requestBody);
	};


	var addItemToCart = function (variantId, quantity, cb) {
		var postData = JSON.stringify({
			"items": [
				{
					"quantity": quantity,
					"id": variantId
				}
			]
		});
		return makeXmlRequest(
			{
				method: "POST",
				url: "/cart/add.js",
				requestBody: postData,
				headers: { "Content-Type": "application/json" }
			},
			function done(data, reason, response) {
				if (data === null) {
					if (response) {
						response = JSON.parse(response);
						var regex = /You can't add more [\w\W]+to the cart/g;
						if (
							response.message === "Cart Error"
							&& response.description.match(regex)
						) {
							return cb(null, response.description.replace("You can't add more", "You can't add that many"));
						} else {
							return cb(null, response.description);
						}
					}
					return cb(null, reason);
				}
				return cb();
			}
		);
	};


	var addItemsToCart = function (itemsArray, cb) {
		var postData = JSON.stringify({
			"items": itemsArray
		});
		return makeXmlRequest({
			method: "POST",
			url: "/cart/add.js",
			requestBody: postData,
			headers: { "Content-Type": "application/json" }
		}, function done(data, reason, response) {
			if (data === null) {
				if (response) {
					response = JSON.parse(response);
					var regex = /You can't add more [\w\W]+to the cart/g;
					if (
						response.message === "Cart Error"
						&& response.description.match(regex)
					) {
						return cb(null, response.description.replace("You can't add more", "You can't add that many"));
					} else {
						return cb(null, response.description);
					}
				}
				return cb(null, reason);
			}
			return cb();
		});
	};

	// private
	var getFormData = function (form) {
		var data = Object.create(null);
		// We add the name and value of all form inputs to our data object.
		var inputTags = ["input", "select", "textarea"];
		inputTags.forEach(function (tag) {
			var elements = Array.from(form.getElementsByTagName(tag));
			elements.forEach(function (element) {
				// For checkbox inputs, only include their value if they are checked.
				if (
					tag === "input"
					&& element.getAttribute("type") === "checkbox"
					&& !element.checked
				) {
					return;
				}

				data[element.getAttribute("name")] = element.value;
			});
		});
		return data;
	};


	/**
	 * @purpose - Submit a form, without reloading the page.
	 * @param {object} options -
	 * 	- form: A form element to gather data, or properties like method/action from.
	 *  - data: An object containing form name value pairs. Only used if form is not preset.
	 *  - action: (optional) The URL string to post the form to. Default is the current url.
	 *  - method: (optional) The HTTP method string used to send the request. Default is "POST"
	 * @param {function} cb - The function to call once we receive a response to our submission request.
	*/
	var submitForm = function (options, cb) {
		try {
			var form = options.form;
			var data = options.data || getFormData(form);
			var method = options.method || "POST";
			var action = options.action || (
				form
				? (form.getAttribute("action") || location.pathname)
				: location.pathname
			);
			// Convert our data object to a URL encoded string.
			var urlEncodedDataPairs = [];
			Object.keys(data).forEach(function (key) {
				urlEncodedDataPairs.push(
					encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
				);
			});
			data = urlEncodedDataPairs.join("&").replace(/%20/g, "+");
			// Post the form, passing the response to our callback.
			return makeXmlRequest({
				method: method,
				url: action,
				requestBody: data,
				headerData: {
					"Content-Type": "application/x-www-form-urlencoded"
				}
			}, cb);
		} catch (exception) {
			return cb(null, exception);
		}
	};


	/**
	 * Requestor
	 * @purpose - To fetch a new version of a section using Shopify's section rendering API.
	 * @param {string} sectionId - The ID of the section to fetch, does not include 'shopify-section-'.
	 * @param {function} cb - The cb we pass the response data to.
	 * @param {string} path - (optional) The path to make the request to.
	 * @param {string} queryString - (optional) E.g. ?variant_id=123456678&prop=value
	 */
	var getFreshSection = function (sectionId, cb, path, queryString) {
		path = path || location.pathname;
		queryString = queryString || location.search;

		var url = (
			queryString !== ""
			? path + queryString + "&section_id=" + sectionId
			: path + "?section_id=" + sectionId
		);

		return makeXmlRequest({
			method: "GET",
			url: url
		}, function (newSectionText, reason) {
			if (newSectionText === null) {
				return cb(null, reason);
			}

			// Parse response
			var domparser = new DOMParser();
			var parsedDoc = domparser.parseFromString(newSectionText, "text/html");
			var newSection = parsedDoc.body.children[0];

			return cb(newSection);
		});
	};


	/**
	 * Requestor
	 * @purpose - To refresh a section without reloading the entire page.
	 * @param {string} sectionId - The ID of the section to fetch, does not include 'shopify-section-'.
	 * @param {function} cb - The cb we call after the section has been replaced, or report errors to.
	 * @param {string} path - (optional) The path to make the request to.
	 * @param {string} queryString - (optional) E.g. ?variant_id=123456678&prop=value
	 */
	var refreshSection = function (sectionId, cb, path, queryString) {
		return getFreshSection(
			sectionId,
			function (newSection, reason) {
				if (newSection === null) {
					return cb(null, reason);
				}

				var oldSection = document.getElementById("shopify-section-" + sectionId);
				if (!oldSection) {
					throw new Error("Can't find old section");
				}

				var sectionParent = oldSection.parentElement;
				sectionParent.insertBefore(newSection, oldSection);
				sectionParent.removeChild(oldSection);

				return cb();
			},
			path,
			queryString
		);
	};


	Utils.export = function () {
		return Object.freeze({
			// General
			waitUntilTrue: waitUntilTrue,
			getUrlParam: getUrlParam,
			runSequence: runSequence,
			runParallel: runParallel,
			// String manipulation.
			capitalize: capitalize,
			camelCase: camelCase,
			// DOM manipulation
			setElementsToHeightOfTallest: setElementsToHeightOfTallest,
			setButtonLoadingState: setButtonLoadingState,
			// Requests
			makeXmlRequest: makeXmlRequest,
			addItemToCart: addItemToCart,
			addItemsToCart: addItemsToCart,
			getFreshSection: getFreshSection,
			refreshSection: refreshSection,
			submitForm: submitForm,
		});
	};

})(PLUG.Utils = Object.create(null));

